<template>
 <div class="container">
   <a class="hyper-section" name="main2"></a>
    <section> <h1> Kontakt oss </h1>
     <p><i class="far fa-envelope"></i>: <a href="mailto:bygg7778@gmail.com">bygg7778@gmail.com</a> </p>
     <p><i class="fas fa-phone-volume"></i>: <span class="phone"> 070-760 89 07 </span> </p>
   <!--<form>
  <label> Name</label>

    <input type="text" name="name">
    
      <label> Email</label>	
      <input type="text" name="Email">
 
      <label>Message</label> 
      <textarea rows="5" cols="100">message</textarea>       
      <input class="button" type="Submit" 
      value="Submit" name="">  
      
      
    </form> <--->
<div style="margin-top:100px " > </div>

   </section>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.phone{
  color:#1266f1;
}
</style>